import { useState, useEffect } from 'react';

export function useGeolocation() {
  const [state, setState] = useState({ loading: true, error: null, lat: null, lng: null });

  useEffect(() => {
    if (!navigator.geolocation) {
      setState({ loading: false, error: 'Geolocation not supported by your browser.', lat: null, lng: null });
      return;
    }
    const id = navigator.geolocation.watchPosition(
      pos => setState({ loading: false, error: null, lat: pos.coords.latitude, lng: pos.coords.longitude }),
      err => {
        const msgs = { 1: 'Location permission denied. Please allow access in browser settings.', 2: 'Could not get your location. Enable Location Services.', 3: 'Location timed out. Please try again.' };
        setState({ loading: false, error: msgs[err.code] || err.message, lat: null, lng: null });
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
    return () => navigator.geolocation.clearWatch(id);
  }, []);

  return state;
}
